import { IStore } from 'store/types';

export const selectDaySegments = () => (state: IStore) => state?.collections?.daySegments;
